export function sanitizeFileNamePart(value: string): string {
  return value
    .trim()
    .replace(/[/\\?%*:|"<>]/g, '_')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .slice(0, 120);
}

/** CSV field with quotes (Excel-safe; easier to read in plain text). */
export function escapeCsvCell(value: string | number | undefined | null): string {
  const s = value === undefined || value === null ? '' : String(value);
  return `"${s.replace(/"/g, '""')}"`;
}

/**
 * Builds RFC 4180–style CSV (CRLF rows), all fields quoted, suitable for Excel.
 */
export function formatCsv(
  headers: string[],
  rows: Record<string, string>[],
): string {
  const headerLine = headers.map(h => escapeCsvCell(h)).join(',');
  const dataLines = rows.map(r =>
    headers.map(col => escapeCsvCell(r[col] ?? '')).join(','),
  );
  return [headerLine, ...dataLines].join('\r\n');
}

export function downloadCsvContent(csvBody: string, fileNameBase: string): void {
  const name = sanitizeFileNamePart(fileNameBase);
  const csvWithBom = `\ufeff${csvBody}`;
  const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = name.endsWith('.csv') ? name : `${name}.csv`;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

export function downloadJson(data: unknown, fileName: string): void {
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: 'application/json;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName.endsWith('.json') ? fileName : `${fileName}.json`;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
